import { ValidationError as PepperValidationError } from '../errors/PepperValidationError';
import { Nullable } from 'utils/types';

export enum AvailableModalActions {
  SELECT_ACTIONS = 'SELECT_ACTIONS',
  SEND_ERRORS = 'SEND_ERRORS',
  VALIDATE_FAILED = 'VALIDATE_FAILED',
  VALIDATE_OK = 'VALIDATE_OK',
  GENERAL_ERROR = 'GENERAL_ERROR',
}

export type Error = string;

export interface State {
  isModalOpen: boolean;
  currentModalAction: AvailableModalActions;

  send: {
    isPending: boolean;
    isSuccess: boolean;
    errors: Error[];
  };

  validateDataAction: {
    isPending: boolean;
    isSuccess: boolean;
    errors: Nullable<PepperValidationError>;
  };

  reviewAction: {
    isModalOpen: boolean;
  };
}

export interface ActionType {}

export interface Action<TPayload = unknown> {
  type: Actions;
  payload: TPayload;
}

export enum Actions {
  /* Common actions */
  RESET = 'CM/CASE/PEPPER/RESET',

  /* Modal actions */
  SET_MODAL_IS_OPEN = 'CM/CASE/PEPPER/SET_MODAL_IS_OPEN',
  SET_MODAL_SCREEN = 'CM/CASE/PEPPER/SET_MODAL_SCREEN',

  /* Send to pepper actions */
  SET_SEND_IN_PROGRESS = 'CM/CASE/PEPPER/SET_SEND_IN_PROGRESS',
  SET_SEND_SUCCESS = 'CM/CASE/PEPPER/SET_SEND_SUCCESS',
  SET_SEND_ERRORS = 'CM/CASE/PEPPER/SET_SEND_ERRORS',

  /* Validate data actions */
  VALIDATE_IN_PROGRESS = 'CM/CASE/PEPPER/VALIDATE_IN_PROGRESS',
  VALIDATE_SUCCESS = 'CM/CASE/PEPPER/VALIDATE_SUCCESS',
  VALIDATE_ERRORS = 'CM/CASE/PEPPER/VALIDATE_ERRORS',

  REVIEW_START = 'CM/CASE/PEPPER/REVIEW_START',
}
